"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const header_section_style_1 = __importDefault(require("./header.section.style"));
const headerSectionLevels = {
    primary: 'primary',
    secondary: 'secondary',
    tertiary: 'tertiary'
};
class HeaderSection extends react_1.Component {
    render() {
        const { children, classes, level, loading } = this.props;
        const typeClass = {
            [classes.primary]: level === headerSectionLevels.primary,
            [classes.secondary]: level === headerSectionLevels.secondary,
            [classes.tertiary]: level === headerSectionLevels.tertiary
        };
        return (jsx_runtime_1.jsx("div", Object.assign({ className: classnames_1.default(classes.root, typeClass), "data-cy": "atomic-header-section", "aria-busy": loading }, { children: children }), void 0));
    }
}
exports.HeaderSection = HeaderSection;
HeaderSection.propTypes = {
    children: prop_types_1.default.node.isRequired,
    classes: prop_types_1.default.object.isRequired,
    level: prop_types_1.default.oneOf([
        headerSectionLevels.primary,
        headerSectionLevels.secondary,
        headerSectionLevels.tertiary
    ]).isRequired,
    loading: prop_types_1.default.bool
};
HeaderSection.defaultProps = {
    loading: false
};
exports.default = react_jss_1.default(header_section_style_1.default)(HeaderSection);
//# sourceMappingURL=header.section.js.map